import { NextSeo } from 'next-seo'

import NavTextNodes from '@data/i18n/nav.json'

import { lang } from '@lib/constants'
import { getMagContent, getMagDoc, getMagTopics } from '@lib/prismic/fetch/documents'

import FeaturedArticleHeader from '@components/magazine/FeaturedArticleHeader'
import MagazineArticleList from '@components/magazine/MagazineArticleList'
import MagazineTopicsNav from '@components/magazine/MagazineTopicsNav'

type Props = {
	posts: any[]
	topicID: string
	totalPages: number
	featuredArticle: any
	featuredTopics: any[]
}

export default function Magazine({
	posts,
	topicID,
	totalPages,
	featuredArticle,
	featuredTopics
}: Props) {
	return (
		<>
			<NextSeo title={NavTextNodes.theMag} />
			<FeaturedArticleHeader featuredArticle={featuredArticle} />
			<MagazineTopicsNav topic={null} featuredTopics={featuredTopics} />
			<MagazineArticleList initialPosts={posts} topicID={topicID} totalPages={totalPages} />
		</>
	)
}

export async function getStaticProps({ previewData }: { previewData: any }) {
	const topics = await getMagTopics(previewData)

	const posts = await getMagContent({ withBodyContent: false, previewData })

	const magazine = await getMagDoc(previewData)
	const featuredArticle = magazine?.data?.featured_articles?.[0] || null
	const featuredTopics = magazine?.data?.featured_topics || []

	return {
		props: {
			posts: posts.results,
			totalPages: posts.total_pages,
			topics,
			featuredArticle,
			featuredTopics
		}
	}
}
